import { render } from "./additionalProperties.vue?vue&type=template&id=24161e57&scoped=true&ts=true"
import script from "./additionalProperties.vue?vue&type=script&lang=ts"
export * from "./additionalProperties.vue?vue&type=script&lang=ts"

import "./additionalProperties.vue?vue&type=style&index=0&id=24161e57&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24161e57"]])

export default __exports__